(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    if (window.__cartDrawerInit) return;
    window.__cartDrawerInit = true;

    const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
    let isUpdating = false;

    function getDrawer() {
      return document.querySelector('[data-cart-drawer]');
    }

    function getSectionId() {
      const drawer = getDrawer();
      const section = drawer?.closest('.shopify-section');
      if (section?.id) {
        return section.id.replace('shopify-section-', '');
      }
      return 'cart-drawer';
    }

    function openDrawer() {
      const drawer = getDrawer();
      if (!drawer) return;
      drawer.classList.add('cart-drawer--open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.setAttribute('scroll-lock', '');
      drawer.querySelector('.cart-drawer__close')?.focus();
    }

    function closeDrawer() {
      const drawer = getDrawer();
      if (!drawer) return;
      drawer.classList.remove('cart-drawer--open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.removeAttribute('scroll-lock');
    }

    function updateCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach((badge) => {
        if (count > 0) {
          badge.textContent = count;
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      });
    }

    async function refreshDrawer() {
      const drawer = getDrawer();
      if (!drawer) return;

      const sectionId = getSectionId();
      const response = await fetch(`${root}?sections=${encodeURIComponent(sectionId)}`);
      const data = await response.json();
      const html = data[sectionId];
      if (!html) return;

      const template = document.createElement('template');
      template.innerHTML = html;
      const newDrawer = template.content.querySelector('[data-cart-drawer]');
      if (!newDrawer) return;

      const wasOpen = drawer.classList.contains('cart-drawer--open');
      const accentStyle = newDrawer.getAttribute('style');
      if (accentStyle) {
        drawer.setAttribute('style', accentStyle);
      }
      drawer.innerHTML = newDrawer.innerHTML;

      if (wasOpen) {
        drawer.classList.add('cart-drawer--open');
        drawer.setAttribute('aria-hidden', 'false');
        document.documentElement.setAttribute('scroll-lock', '');
      } else {
        drawer.classList.remove('cart-drawer--open');
        drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.removeAttribute('scroll-lock');
      }

      const cartResponse = await fetch(`${root}cart.js`);
      const cart = await cartResponse.json();
      updateCartCount(cart.item_count);
    }

    async function changeQuantity(lineKey, variantId, quantity) {
      if (isUpdating) return;
      isUpdating = true;

      const payload = { quantity };
      if (lineKey) {
        payload.id = lineKey;
      } else if (variantId) {
        payload.id = variantId;
      }

      try {
        const response = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          console.error('Cart update failed', await response.json());
          return;
        }

        await refreshDrawer();
      } finally {
        isUpdating = false;
      }
    }

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-cart-drawer-open]')) {
        event.preventDefault();
        openDrawer();
        return;
      }

      const drawer = getDrawer();
      if (!drawer || !drawer.contains(event.target)) return;

      const closeTrigger = event.target.closest('[data-cart-drawer-close]');
      if (closeTrigger) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      const cartItem = event.target.closest('[data-cart-item]');
      if (!cartItem || isUpdating) return;

      const lineKey = cartItem.dataset.lineKey;
      const variantId = cartItem.dataset.variantId;
      const valueEl = cartItem.querySelector('[data-quantity-value]');
      const current = parseInt(valueEl?.textContent?.trim() || '1', 10);

      if (event.target.closest('[data-quantity-decrease]')) {
        event.preventDefault();
        changeQuantity(lineKey, variantId, Math.max(0, current - 1));
        return;
      }

      if (event.target.closest('[data-quantity-increase]')) {
        event.preventDefault();
        changeQuantity(lineKey, variantId, current + 1);
        return;
      }

      if (event.target.closest('[data-cart-remove]')) {
        event.preventDefault();
        changeQuantity(lineKey, variantId, 0);
      }
    });

    document.addEventListener('keydown', (event) => {
      const drawer = getDrawer();
      if (event.key === 'Escape' && drawer?.classList.contains('cart-drawer--open')) {
        closeDrawer();
      }
    });

    window.addEventListener('pageshow', () => {
      closeDrawer();
    });

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector?.('[data-cart-drawer]')) {
        closeDrawer();
      }
    });

    window.openCartDrawer = openDrawer;
    window.closeCartDrawer = closeDrawer;
    window.refreshCartDrawer = refreshDrawer;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    const form = document.querySelector('[data-collection-filters]');
    if (!form) return;

    form.querySelectorAll('select').forEach((select) => {
      select.addEventListener('change', () => {
        form.requestSubmit();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-header]');
    const spacer = document.querySelector('[data-header-spacer]');
    if (!header) return;

    const announcement = document.querySelector('.announcement-bar');
    const mobileMenu = header.querySelector('[data-header-mobile-menu]');
    const menuToggle = header.querySelector('[data-header-menu-toggle]');
    const menuToggleLabel = header.querySelector('[data-header-menu-toggle-label]');
    const searchDialog = document.querySelector('[data-header-search-dialog]');
    const searchOpen = header.querySelector('[data-header-search-open]');
    const searchCloses = searchDialog?.querySelectorAll('[data-header-search-close]') ?? [];

    function updateHeaderHeight() {
      if (!spacer) return;
      const height = header.offsetHeight;
      spacer.style.height = `${height}px`;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    if (announcement) {
      const pinObserver = new IntersectionObserver(
        ([entry]) => {
          header.classList.toggle('header--pinned-top', !entry.isIntersecting);
        },
        { threshold: 0 }
      );
      pinObserver.observe(announcement);
    } else {
      header.classList.add('header--pinned-top');
    }

    function setMenuOpen(isOpen) {
      header.classList.toggle('header--menu-open', isOpen);
      if (mobileMenu) {
        mobileMenu.hidden = !isOpen;
      }
      if (menuToggle) {
        menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
      if (menuToggleLabel) {
        menuToggleLabel.textContent = isOpen
          ? menuToggleLabel.dataset.closeLabel
          : menuToggleLabel.dataset.openLabel;
      }
      updateHeaderHeight();
    }

    function closeMenu() {
      setMenuOpen(false);
    }

    function openMenu() {
      setMenuOpen(true);
    }

    menuToggle?.addEventListener('click', () => {
      if (header.classList.contains('header--menu-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    function openDialog(dialog, focusSelector) {
      if (!dialog) return;
      dialog.showModal();
      dialog.setAttribute('scroll-lock', '');
      if (focusSelector) {
        dialog.querySelector(focusSelector)?.focus();
      }
    }

    function closeDialog(dialog) {
      if (!dialog) return;
      dialog.close();
      dialog.removeAttribute('scroll-lock');
    }

    searchOpen?.addEventListener('click', () => {
      openDialog(searchDialog, '.header__search-input');
    });
    searchCloses.forEach((button) => {
      button.addEventListener('click', () => closeDialog(searchDialog));
    });

    searchDialog?.addEventListener('click', (event) => {
      if (event.target === searchDialog) closeDialog(searchDialog);
    });

    searchDialog?.addEventListener('close', () => searchDialog.removeAttribute('scroll-lock'));

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (searchDialog?.open) closeDialog(searchDialog);
      if (header.classList.contains('header--menu-open')) closeMenu();
    });

    window.addEventListener('resize', () => {
      if (window.matchMedia('(min-width: 750px)').matches) {
        closeMenu();
      }
      updateHeaderHeight();
    });

    const resizeObserver = new ResizeObserver(updateHeaderHeight);
    resizeObserver.observe(header);

    updateHeaderHeight();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const initialized = new WeakSet();

    function initHeroBanner(root) {
      if (!root || initialized.has(root)) return;

      const slides = [...root.querySelectorAll('[data-hero-slide]')];
      if (!slides.length) return;

      initialized.add(root);

      const dots = [...root.querySelectorAll('[data-hero-dot]')];
      const autoplayEnabled = root.dataset.autoplay === 'true';
      const autoplayDuration = Number.parseInt(root.dataset.autoplayDuration, 10) || 5000;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (prefersReducedMotion) {
        root.style.setProperty('--hero-transition-duration', '0ms');
      }

      let current = 0;
      let timer = null;

      function applySlideAspect(slide) {
        if (!slide) return;
        const { aspectMobileW, aspectMobileH, aspectDesktopW, aspectDesktopH } = slide.dataset;
        if (aspectMobileW && aspectMobileH) {
          root.style.setProperty('--hero-aspect-mobile-w', aspectMobileW);
          root.style.setProperty('--hero-aspect-mobile-h', aspectMobileH);
        }
        if (aspectDesktopW && aspectDesktopH) {
          root.style.setProperty('--hero-aspect-desktop-w', aspectDesktopW);
          root.style.setProperty('--hero-aspect-desktop-h', aspectDesktopH);
        }
      }

      function setActive(index) {
        const nextIndex = (index + slides.length) % slides.length;
        const activeSlide = slides[nextIndex];

        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === nextIndex);
        });

        dots.forEach((dot, i) => {
          const isActive = i === nextIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        applySlideAspect(activeSlide);
        current = nextIndex;
      }

      function next() {
        setActive(current + 1);
      }

      function stopAutoplay() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function startAutoplay() {
        if (!autoplayEnabled || slides.length < 2 || prefersReducedMotion) return;
        stopAutoplay();
        timer = setInterval(next, autoplayDuration);
      }

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = Number.parseInt(dot.dataset.slideIndex, 10);
          if (Number.isNaN(index)) return;
          setActive(index);
          startAutoplay();
        });
      });

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);

      setActive(0);
      startAutoplay();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-hero-banner]').forEach(initHeroBanner);
    }

    initAll();

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const lightbox = document.querySelector('[data-review-lightbox]');
    const lightboxImage = document.querySelector('[data-review-lightbox-image]');
    const lightboxClose = document.querySelector('[data-review-lightbox-close]');

    function openLightbox(src, alt) {
      if (!lightbox || !lightboxImage) return;
      lightboxImage.src = src;
      lightboxImage.alt = alt || '';
      lightbox.showModal();
      lightbox.setAttribute('scroll-lock', '');
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.close();
      lightbox.removeAttribute('scroll-lock');
      if (lightboxImage) {
        lightboxImage.removeAttribute('src');
        lightboxImage.alt = '';
      }
    }

    document.querySelectorAll('[data-review-photo]').forEach((button) => {
      button.addEventListener('click', () => {
        openLightbox(button.dataset.photoSrc, button.dataset.photoAlt);
      });
    });

    lightboxClose?.addEventListener('click', closeLightbox);

    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) closeLightbox();
    });

    lightbox?.addEventListener('close', () => lightbox.removeAttribute('scroll-lock'));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && lightbox?.open) closeLightbox();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const section = document.querySelector('[data-product-section]');
    if (!section) return;

    const product = JSON.parse(section.querySelector('[data-product-json]')?.textContent || '{}');
    const form = section.querySelector('#ProductForm');
    const variantInput = section.querySelector('[data-variant-input]');
    const optionButtons = section.querySelectorAll('[data-option-value]');
    const comparePriceEl = section.querySelector('[data-compare-price]');
    const currentPriceEl = section.querySelector('[data-current-price]');
    const installmentsEl = section.querySelector('[data-installments]');
    const pixPriceEl = section.querySelector('[data-pix-price]');
    const pixNoteEl = section.querySelector('[data-pix-note]');
    const addToCartBtn = section.querySelector('[data-add-to-cart]');
    const buyNowBtn = section.querySelector('[data-buy-now]');
    const returnToInput = section.querySelector('[data-return-to-checkout]');
    const quantityInput = section.querySelector('[data-quantity-input]');
    const slides = section.querySelectorAll('[data-gallery-slide]');
    const thumbs = section.querySelectorAll('[data-gallery-thumb]');
    const prevBtn = section.querySelector('[data-gallery-prev]');
    const nextBtn = section.querySelector('[data-gallery-next]');

    const installmentCount = Number(section.dataset.installmentCount) || 12;
    const pixDiscount = Number(section.dataset.pixDiscount) || 0;
    const showInstallments = section.dataset.showInstallments === 'true';
    const i18n = JSON.parse(section.querySelector('[data-product-i18n]')?.textContent || '{}');
    const moneyFormat = section.dataset.shopMoneyFormat || '';
    const shopCurrency = section.dataset.shopCurrency || 'BRL';

    const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
    let activeSlide = 0;

    function formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function' && moneyFormat) {
        return Shopify.formatMoney(cents, moneyFormat);
      }
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: shopCurrency,
      });
    }

    function getSelectedOptions() {
      const options = [];
      product.options.forEach((name, index) => {
        const selected = section.querySelector(
          `[data-option-index="${index}"].is-selected`
        );
        options.push(selected?.dataset.optionValue || product.variants[0]?.options[index]);
      });
      return options;
    }

    function findVariant() {
      const selected = getSelectedOptions();
      return product.variants.find((variant) =>
        variant.options.every((value, index) => value === selected[index])
      );
    }

    function updateGalleryForVariant(variant) {
      if (!variant?.featured_media?.id) return;
      const mediaId = variant.featured_media.id;
      slides.forEach((slide, index) => {
        const isMatch = Number(slide.dataset.mediaId) === mediaId;
        slide.hidden = !isMatch;
        slide.classList.toggle('is-active', isMatch);
        if (isMatch) activeSlide = index;
      });
      thumbs.forEach((thumb, index) => {
        thumb.classList.toggle('is-active', index === activeSlide);
      });
      updateGalleryNav();
    }

    function updateVariantUI() {
      const variant = findVariant();
      if (!variant || !variantInput) return;

      variantInput.value = variant.id;

      if (currentPriceEl) {
        currentPriceEl.textContent = formatMoney(variant.price);
      }

      if (comparePriceEl) {
        if (variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.hidden = true;
        }
      }

      if (installmentsEl && showInstallments && installmentCount > 0 && i18n.installments) {
        const amount = formatMoney(Math.round(variant.price / installmentCount));
        installmentsEl.textContent = i18n.installments
          .replace('@@COUNT@@', installmentCount)
          .replace('@@AMOUNT@@', amount);
      }

      if (pixPriceEl) {
        const pixPrice = Math.round((variant.price * (100 - pixDiscount)) / 100);
        const savings = variant.price - pixPrice;
        pixPriceEl.textContent = formatMoney(pixPrice);
        if (pixNoteEl && i18n.pix_note) {
          pixNoteEl.textContent = i18n.pix_note.replace('@@AMOUNT@@', formatMoney(savings));
        }
      }

      const available = variant.available;
      if (addToCartBtn) {
        addToCartBtn.disabled = !available;
        addToCartBtn.textContent = available ? i18n.add_to_cart : i18n.sold_out;
      }
      if (buyNowBtn) {
        buyNowBtn.disabled = !available;
      }

      updateGalleryForVariant(variant);
      updateOptionAvailability();
    }

    function updateOptionAvailability() {
      if (!product.options) return;

      product.options.forEach((optionName, optionIndex) => {
        section.querySelectorAll(`[data-option-index="${optionIndex}"]`).forEach((button) => {
          const testOptions = getSelectedOptions();
          testOptions[optionIndex] = button.dataset.optionValue;
          const match = product.variants.find((variant) =>
            variant.options.every((value, idx) => value === testOptions[idx])
          );
          button.disabled = !match;
        });
      });
    }

    function showSlide(index) {
      if (!slides.length) return;
      activeSlide = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === activeSlide;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === activeSlide);
        if (i === activeSlide) {
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
      updateGalleryNav();
    }

    function updateGalleryNav() {
      if (prevBtn) prevBtn.disabled = slides.length <= 1;
      if (nextBtn) nextBtn.disabled = slides.length <= 1;
    }

    optionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const index = button.dataset.optionIndex;
        section.querySelectorAll(`[data-option-index="${index}"]`).forEach((el) => {
          el.classList.remove('is-selected');
        });
        button.classList.add('is-selected');
        updateVariantUI();
      });
    });

    prevBtn?.addEventListener('click', () => showSlide(activeSlide - 1));
    nextBtn?.addEventListener('click', () => showSlide(activeSlide + 1));

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        showSlide(Number(thumb.dataset.mediaIndex));
      });
    });

    section.querySelector('[data-quantity-decrease]')?.addEventListener('click', () => {
      const current = Math.max(1, parseInt(quantityInput.value, 10) || 1);
      quantityInput.value = Math.max(1, current - 1);
    });

    section.querySelector('[data-quantity-increase]')?.addEventListener('click', () => {
      const current = parseInt(quantityInput.value, 10) || 1;
      quantityInput.value = current + 1;
    });

    function updateCartCount(count) {
      const badge = document.querySelector('[data-cart-count]');
      if (!badge) return;
      if (count > 0) {
        badge.textContent = count;
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    }

    addToCartBtn?.addEventListener('click', async () => {
      const variantId = variantInput?.value;
      const quantity = parseInt(quantityInput?.value || '1', 10);
      if (!variantId || addToCartBtn.disabled) return;

      addToCartBtn.classList.add('is-loading');

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity }),
        });

        if (!response.ok) throw new Error('Add to cart failed');

        const cart = await fetch(`${root}cart.js`).then((res) => res.json());
        updateCartCount(cart.item_count);

        if (typeof window.refreshCartDrawer === 'function') {
          await window.refreshCartDrawer();
        }

        window.openCartDrawer?.();
      } catch (error) {
        console.error(error);
      } finally {
        addToCartBtn.classList.remove('is-loading');
      }
    });

    buyNowBtn?.addEventListener('click', () => {
      if (returnToInput) {
        returnToInput.disabled = false;
      }
    });

    updateGalleryNav();
    updateOptionAvailability();
    updateVariantUI();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true') return;

        const observer = new IntersectionObserver(
          (entries, intersectionObserver) => {
            if (!entries[0]?.isIntersecting) return;
            intersectionObserver.disconnect();
            this.loadRecommendations();
          },
          { rootMargin: '0px 0px 400px 0px' }
        );

        observer.observe(this);
      }

      async loadRecommendations() {
        const url = this.dataset.url;
        if (!url) return;

        try {
          const response = await fetch(url);
          if (!response.ok) return;

          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const source = doc.querySelector('[data-related-products]');
          const target = this.querySelector('[data-related-products]');

          if (!source?.innerHTML.trim() || !target) return;

          target.innerHTML = source.innerHTML;
          target.hidden = false;
          this.dataset.loaded = 'true';
          window.bindProductCardAddToCart?.(this);
        } catch (error) {
          console.error(error);
        }
      }
    }

    if (!customElements.get('product-recommendations')) {
      customElements.define('product-recommendations', ProductRecommendations);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weekly-highlights"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');

    function updateCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach((badge) => {
        if (count > 0) {
          badge.textContent = count;
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      });
    }

    document.querySelectorAll('[data-weekly-add-to-cart]').forEach((button) => {
      button.addEventListener('click', async () => {
        const variantId = button.dataset.variantId;
        if (!variantId || button.disabled) return;

        button.classList.add('is-loading');

        try {
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          });

          if (!response.ok) throw new Error('Add to cart failed');

          const cart = await fetch(`${root}cart.js`).then((res) => res.json());
          updateCartCount(cart.item_count);

          if (typeof window.refreshCartDrawer === 'function') {
            await window.refreshCartDrawer();
          }

          window.openCartDrawer?.();
        } catch (error) {
          console.error(error);
        } finally {
          button.classList.remove('is-loading');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
